import { render, staticRenderFns } from "./RefundRequestHistory.vue?vue&type=template&id=06bf5c4e"
import script from "./RefundRequestHistory.vue?vue&type=script&lang=js"
export * from "./RefundRequestHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports